<template>
  <Box class="analytics__container">
    <Box class="analytics__content">
      <Box class="analytics__text" is-flex flex-direction="column" gap="6">
        <Box is-flex flex-direction="column" gap="1">
          <Heading size="h6" color="orange" letter-spacing="4" is-uppercase>{{ $t('pages.ssr_landing.analytics.subtitle') }}</Heading>
          <Heading class="analytics__title" color="purple-pink">{{ $t('pages.ssr_landing.analytics.title') }}</Heading>
        </Box>
        <CustomText size="large">{{ $t('pages.ssr_landing.analytics.description') }}</CustomText>
        <a :href="$locatedLink('/features/podcast-analytics/')">
          <Button class="link-button-arrow-animation" variant="transparent" size="medium" border-radius="large" has-border>
            <CustomText size="large" weight="bold">{{ $t('learn_more') }}</CustomText>
            <div class="link-button-arrow-animation__i">
              <SmallArrowIcon />
            </div>
          </Button>
        </a>
      </Box>
      <Box class="analytics__img">
        <Glow class="analytics__glow" />
        <img src="/images/landing/analytics.png" srcset="/images/landing/analytics@2x.png 2x">
      </Box>
    </Box>
  </Box>
</template>

<script>
import Glow from './svg/Glow.vue'
import Box from '@/components/common/Box/Box'
import Heading from '@/components/common/Heading/Heading'
import CustomText from '@/components/common/CustomText/CustomText'
import Button from '@/components/common/Button/Button'
import SmallArrowIcon from '@/components/icons/default/ArrowSmall'

export default {
  components: {
    Glow,
    Box,
    Heading,
    CustomText,
    Button,
    SmallArrowIcon
  }
}
</script>

<style lang="scss" scoped>
.analytics {
  &__container {
    position: relative;
    padding: 0 $gap;
  }

  &__content {
    display: flex;
    flex-direction: row;
    gap: $gap * 2;
    max-width: 1200px;
    margin: 0 auto;
    align-items: center;
    justify-content: center;

    @include display-less(tablet) {
      gap: 0;
      flex-direction: column;
    }
  }

  &__title {
    @include display-less(tablet) {
      font-size: 32px;
      line-height: 120%;
    }
  }

  &__text {
    padding: $gap * 3.5 0;
    margin: auto 0;
    flex: 1 1;
  }

  &__img {
    flex: 1 1;
    position: relative;
  }

  &__glow {
    top: 200px;
    right: 0;
    position: absolute;
    transform: translate(0, -50%);
    width: 464px;
    height: 464px;
    pointer-events: none;
  }
}
</style>
